import { useMutation, useQueryClient } from '@tanstack/vue-query'

import { employeeKeys } from '../../employees/composables/useEmployeeQuery'

import { ShiftID } from '../../shifts/models/shift'
import { SiteID } from '../../sites/models/site'

import { useEventStore } from '../../common/eventStore'

import { ShiftCheckInForm, checkIn, checkOut, deleteCheckIn, deleteCheckOut } from '../shiftCheckInService'
import { EmployeeID } from '../../employees/models/employee'

export function useShiftCheckInMutation() {
  const eventStore = useEventStore()
  const queryClient = useQueryClient()

  return useMutation<
    void,
    Error,
    { siteId: SiteID; shiftId: ShiftID; form: ShiftCheckInForm }
  >({
    mutationFn: async (variables) => {
      return checkIn(variables.siteId, variables.shiftId, variables.form)
    },
    onSuccess: async () => {
      eventStore.addUpdateToast({ summary: 'Checked In' })
    },
    onSettled: async (_data, _error, variables) => {
      // Invalidate any queries that may be affected by the check-in
      await queryClient.invalidateQueries({
        queryKey: employeeKeys.listByShiftOnly(variables.siteId, variables.shiftId),
      })
    },
  })
}

export function useShiftCheckInDeleteMutation() {
    const eventStore = useEventStore()
    const queryClient = useQueryClient()

    return useMutation<
        void,
        Error,
        { siteId: SiteID; shiftId: ShiftID; onBehalfOfEmployeeId?: EmployeeID }
    >({
        mutationFn: async (variables) => {
            return deleteCheckIn(variables.siteId, variables.shiftId, variables.onBehalfOfEmployeeId)
        },
        onSuccess: async () => {
            eventStore.addUpdateToast({ summary: 'Check-In Deleted' })
        },
        onSettled: async (_data, _error, variables) => {
            // Invalidate any queries that may be affected by the check-in deletion
            await queryClient.invalidateQueries({
                queryKey: employeeKeys.listByShiftOnly(variables.siteId, variables.shiftId),
            })
        },
    })
}

export function useShiftCheckOutMutation() {
  const eventStore = useEventStore()
  const queryClient = useQueryClient()

  return useMutation<
    void,
    Error,
    { siteId: SiteID; shiftId: ShiftID; form: ShiftCheckInForm }
  >({
    mutationFn: async (variables) => {
      return checkOut(variables.siteId, variables.shiftId, variables.form)
    },
    onSuccess: async () => {
      eventStore.addUpdateToast({ summary: 'Checked Out' })
    },
    onSettled: async (_data, _error, variables) => {
      // Invalidate any queries that may be affected by the check-in
      await queryClient.invalidateQueries({
        queryKey: employeeKeys.listByShiftOnly(variables.siteId, variables.shiftId),
      })
    },
  })
}

export function useShiftCheckOutDeleteMutation() {
    const eventStore = useEventStore()
    const queryClient = useQueryClient()

    return useMutation<
        void,
        Error,
        { siteId: SiteID; shiftId: ShiftID; onBehalfOfEmployeeId?: EmployeeID }
    >({
        mutationFn: async (variables) => {
            return deleteCheckOut(variables.siteId, variables.shiftId, variables.onBehalfOfEmployeeId)
        },
        onSuccess: async () => {
            eventStore.addUpdateToast({ summary: 'Check-Out Deleted' })
        },
        onSettled: async (_data, _error, variables) => {
            // Invalidate any queries that may be affected by the check-out deletion
            await queryClient.invalidateQueries({
                queryKey: employeeKeys.listByShiftOnly(variables.siteId, variables.shiftId),
            })
        },
    })
}
